import React from 'react';

import { QRCodeSVG } from 'qrcode.react';
import { c } from 'ttag';

import { OtpInput } from '@freelancelabs/components';

export const TOTP_CODE_LENGTH = 6;

interface Props {
    uri: string;
    secret: string;
    code: string;
    onCode: (code: string) => void;
    error?: string;
    busy?: boolean;
}

// Display only: the secret is never re-parsed from this grouped string.
const groupBy4 = (secret: string) => secret.replace(/(.{4})/g, '$1 ').trim();

// Renders no title, dialog or buttons: the gesture is shared by the profile (a closable Modal)
// and the entry barrier (in-page, not closable), but the frame belongs to each caller.
const TotpPairing = ({ uri, secret, code, onCode, error, busy }: Props) => (
    <>
        <div className="totp-step">
            <span className="totp-step-num" aria-hidden="true">
                1
            </span>
            <div>
                <b className="totp-step-title">{c('Totp pairing').t`Scan this code with your authenticator app`}</b>
                <div className="totp-qr">
                    <QRCodeSVG value={uri} size={158} marginSize={2} />
                </div>
                <span className="totp-key">{groupBy4(secret)}</span>
                <p className="totp-secret">{c('Totp pairing').t`Cannot scan? Enter this key by hand in your app.`}</p>
            </div>
        </div>

        <div className="totp-step">
            <span className="totp-step-num" aria-hidden="true">
                2
            </span>
            <div>
                <b className="totp-step-title">{c('Totp pairing').t`Enter the code your app displays`}</b>
                <div className="mt-3">
                    <OtpInput
                        value={code}
                        onValue={onCode}
                        length={TOTP_CODE_LENGTH}
                        disabled={busy}
                        error={Boolean(error)}
                        ariaLabel={c('Mfa label').t`6-digit verification code`}
                    />
                </div>
                <p className="mfa-statut" role="status">
                    {error}
                </p>
            </div>
        </div>
    </>
);

export default TotpPairing;
